var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.70546 11.6259L13.6555 6.11321C13.8473 5.93557 14.1434 5.93557 14.3352 6.1132L14.3432 6.12068C14.5568 6.31856 14.5568 6.65635 14.3432 6.85423L8.78904 12.0002L14.3432 17.1462C14.5568 17.344 14.5568 17.6818 14.3432 17.8797L14.3352 17.8872C14.1434 18.0648 13.8473 18.0648 13.6555 17.8872L7.70546 12.3744L7.69739 12.367C7.51051 12.1938 7.48715 11.9136 7.62731 11.7136C7.64734 11.6851 7.6707 11.6582 7.69739 11.6334L7.70546 11.6259Z"}));
}

Back.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Back;

Back.default = Back;
